import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const GoalsPage = lazy(() => import('./GoalsPage'));

const GoalsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Goals,
  routes: [
    {
      path: 'goals',
      element: <GoalsPage />,
    },
  ],
};

export default GoalsConfig;
